var SecureMessageWidget = require('./../secure-message/SecureMessageWidget');
var SecureMessageBillView = require('./../bill/SecureMessageBillView');
var SecureMessageModel = require('./../secure-message/SecureMessageModel');
var SecureMessageAppointmentView = require('./../ereg/patient-appointments/SecureMessageAppointmentView');
var financialFeatureService = require('./../financial/financialFeatureService');

var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');
var DemographicsDataBehavior = require('./../demographics/DemographicsDataBehavior');
var _ = require('underscore');

var VIEW_NAME = 'dashboard.todo';

/**
 * Customizations to the SecureMessageWidget specific to the dashboard page to show the TODO items.
 * @class TodoListWidget
 * @constructor
 * @extends SecureMessageWidget
 */
module.exports = SecureMessageWidget.extend({
  moduleNamespace: VIEW_NAME,

  headerMessageKey: VIEW_NAME + '.label',
  noDataMessageKey: VIEW_NAME + '.noMessages',
  loadingMessageKey: VIEW_NAME + '.loading',
  fetchFailedMessageKey: VIEW_NAME + '.fetchFailed',

  behaviors: _.extend({}, SecureMessageWidget.prototype.behaviors, {
   demographics: {
     behavior: DemographicsDataBehavior,
     returnSingleResult: true,
     renderOnFetch: true,
     id: { property: '_patientVecnaId' }
   }
  }),

  /**
   * @method initialize
   * @override
   * Checks to see whether the financial feature is
   * activate for whether bills should be included
   * within the Dashboard "To Do" section.
   */
  initialize: function(options) {
    _.bindAll(this, '_checkPayAbility', '_updateBillStates');

    this._patientVecnaId = options.patientVecnaId;

    SecureMessageWidget.prototype.initialize.apply(this, arguments);
    this.listenTo(financialFeatureConfigModel, 'load-complete', this._updateBillCriteria);
    financialFeatureConfigModel.loadOnce();

    financialFeatureService.fetchPayAbility(options.patientVecnaId).then(this._checkPayAbility);

    var secureMessageDataBehavior = this.getBehavior('secureMessage');
    this.listenTo(secureMessageDataBehavior, 'fetched', this._updateBillStates);
    this.listenTo(secureMessageDataBehavior.data, 'change:billDTO.externalBill.status', this._updateBillCriteria);

    var demographicsDataBehavior = this.getBehavior('demographics');
    this.listenTo(demographicsDataBehavior, 'fetched', this._checkDemographics);
  },


  /**
   * Determines which secure message view to use.
   * @override
   * @method itemView
   */
  itemView: function(model) {
    var secureMessageType = model.get('type');
    if (secureMessageType === SecureMessageModel.MESSAGE_TYPES.BILL) {
      return SecureMessageBillView;
    } else if (secureMessageType === SecureMessageModel.MESSAGE_TYPES.APPOINTMENT) {
      return SecureMessageAppointmentView;
    } else {
      throw 'Unsupported secure message type for the todo list: ' + model.get('type');
    }
  },

  /**
   * The Todo Message Criteria selecting the messages to display which include bills and appointments.
   *
   * @property criteria {Object}
   *   @property criteria.isPatient {Boolean} username restrictions apply to patient usernames only.
   *   @property criteria.vecnaIds {Array} Array of vecnaId restrictions
   *   @property criteria.billCriteria {Object} BillMessageCriteria - restrictions on bill messages.
   *     @property criteria.billCriteria.billCriteria {Object} restrictions on the bill itself.
   *       @property criteria.billCriteria.billCriteria.current {Boolean} only show the latest version of each bill.
   *       @property criteria.billCriteria.billCriteria.show {String} only show bills that are marked by the inbound integration as showable.
   *       @property criteria.billCriteria.billCriteria.statuses {Array} the statuses of the bills to filter which will show.
   *       @property criteria.billCriteria.billCriteria.minAccountBalance {String} only show bills with an account balance >= 0.01.
   *   @property criteria.appointmentCriteria {Object} AppointmentMessageCriteria - restrictions on appointment messages.
   *     @property criteria.appointmentCriteria.externalAppointmentCriteria {Object} restrictions on the external appointment.
   *       @property criteria.appointmentCriteria.externalAppointmentCriteria.cancelled {Boolean} cancelled messages not included.
   *       @property criteria.appointmentCriteria.externalAppointmentCriteria.dateCategory {String} only show appointments that are after today.
   */
  criteria: function() {
    // Copy the initial criteria so we can modify it.
    var criteria = _.extend({}, this.initialRootCriteria);

    // We only want to return the bill object if all Portal Payment functionality is enabled
    if (financialFeatureConfigModel.isAllPortalPaymentsEnabled()) {
      criteria.billCriteria = {
        billCriteria: this.initialBillCriteria
      };
    }
    return criteria;
  },

  initialRootCriteria: {
    appointmentCriteria: {
      externalAppointmentCriteria: {
        // cancelled messages not included
        cancelled: false,
        // only show appointments that are after today
        dateCategory: 'FUTURE'
      }
    },
    // username restrictions apply to patient usernames only
    isPatient: true,
    // no vecnaId restrictions
    vecnaIds: null,
    pagingAndSorting: {
      pageNumber: 0,
      orderingMap: {
        actionDate: true
      },
      pageSize: 7
    }
  },

  initialBillCriteria: {
    // only show the latest version of each bill.
    current: true,
    // the statuses of the bills to filter which will show
    statuses: ['UNPAID'],
    // show bills that are marked by the inbound integration as showable
    show: true,
    // only show bills with an account balance >= 0.01
    minAccountBalance: 0.01
  },

  _updateBillCriteria: function() {
    this.set('criteria.billCriteria.billCriteria', this.initialBillCriteria);
  },

  /**
   * Check patient's ability to pay bills
   * @private
   */
  _checkPayAbility: function() {
    if (financialFeatureConfigModel.get('enabled')) {
      var abilityToPayInfo = financialFeatureService.getAbleToPayState(this._patientVecnaId);
      if (!abilityToPayInfo.ableToPay) {
        this.set('additionalInformationKey', 'financial.feature.config.payment.blocked.PATIENT_PORTAL.' + abilityToPayInfo.unableToPayReason);
      }
      this._updateBillStates();
    }
  },

  /**
   * Update the payment allowed state on each bill
   * @method _updateBillStates
   * @private
   */
  _updateBillStates: function() {
    var abilityToPayInfo = financialFeatureService.getAbleToPayState(this._patientVecnaId);
    _.each(this.getItemViews(), function(itemView) {
      if (itemView.model.get('type') === SecureMessageModel.MESSAGE_TYPES.BILL) {
        itemView.setAbleToPay(abilityToPayInfo.ableToPay);
      }
    });
  },

  /**
   * Show error message if fetching demographics failed.
   * @method _checkDemographics
   * @param fetchStatus {Object} fetch status and response of demographics data
   * @private
   */
  _checkDemographics: function(fetchStatus) {
    var fetchFailed = fetchStatus.status === 'failed';
    if (fetchFailed) {
      this.set('additionalInformationKey', 'billsDueListWidget.fetchDemographicsFailed');
    }
  }
});
